import { ICommonSettings, IFirebaseIOSSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigFirebaseIOSSettings } from "./app-settings-config-firebase-ios";

export interface IConfigFirebaseInputState {
  showModal: boolean;
  editingFirebaseId: string;
}

export interface IConfigFirebaseInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigFirebaseIOSInput extends PureComponent<IConfigFirebaseInputProps, IConfigFirebaseInputState> {
  formInputName = ["iosConfig", "firebaseSettingsId"];

  constructor(props: IConfigFirebaseInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingFirebaseId: ""
    };
  }

  openModal = () => {
    this.setState({ editingFirebaseId: "", showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingFirebase = (id: string) => {
    this.setState({ editingFirebaseId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as IFirebaseIOSSetting,
      ...(commonSettings.iosFirebaseSettings || [])
    ];

    return (
      <>
        <ConfigFirebaseIOSSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingFirebaseId={this.state.editingFirebaseId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />

        <ConfigSettingSelect
          label="Settings"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="ios_firebase_helptext"
          onAddNew={this.openModal}
          onEdit={this.setEditingFirebase}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="iosFireBaseSettingsDropdown"
          addNewTestId="iosFirebaseSettingAddNewButton"
          editTestId="firebaseSettingEditButton"
        />
      </>
    );
  }
}
